<template>
    <div class="col-lg-3 col-md-4 col-12 mb-4 pb-2">
        <router-link :to="localePath({ name: 'blog-detail', params: { slug: item.slug } })">
            <div class="blog_flex">
                <div class="blog_img"> 
                    <img class="radious_eight" height="616" width="556" :src="item.image" :alt="item.title" />
                </div>
                <div class="blog_title">
                    <h4 class="my-3 font-active">{{item.title}}</h4>
                    <div class="read_more">read more</div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script setup>

    const { item } = defineProps(['item'])
    const localePath = useLocalePath()
    // console.log(item, 'inside preview');
</script>

<style scoped>
  
    .read_more {
        border: 1.5px solid var(--green);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--green);
        text-transform: uppercase;
        font-size: 16px;
        border-radius: 4px;
    }
    a{
        color: #000;
        /* border: 1px solid #eaeaea; */
        /* padding: 10px; */
        display: inline-block;
    }
    a:hover{
        color: #000;
    }
    
    h4 {
        font-size: 18px;
        line-height: 1.5;
        min-height: 80px;
    
    }
    @media(max-width: 1350px){
        h4{
            font-size: 16px;
        }
    }
    @media(max-width: 992px){
        h4 {
            min-height: 75px;
        }
        img {
            width: 100%;
            min-height: 210px;
        }
        .blog_banner h3{
            font-size: 22px;
        }
        span {
            font-size: 14px;
        }
    }
    @media(max-width: 767px){
        .blog_flex {
            display: flex;
            align-items: flex-start;
        }
        .blog_img {
            width: 30%;
        }
        .blog_title {
            width: 70%;
            padding-left: 20px;
        }
        img {
            width: 100%;
            min-height: auto;
        }
        h4 {
            font-size: 15px;
            min-height: auto;
            margin: 0 0 10px 0 !important;
        }
        .read_more {
            height: 32px;
            font-size: 14px;
            width: 130px;
        }
    }
</style>
